import Vue from 'vue'
import Vuex, { Store } from 'vuex'
import createLogger from 'vuex/dist/logger'
import apiIndexedDB from '../components/indexedDB'

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({ 
    state: {        
        profilePhoto: require('../assets/pictures/profile.png'),//"/dist/profile.png",
        guidUser: null,
        userToken: null,
        userName: null,
        user: null,
        email: null,
        pdv:null,
        guidClient: null,
        guidTender: null,
        clientName: null,
        clientEdrpo: null,
        ip: null,
        tender:null, 
        viewType:null,     
        listRole: {
            client: false,
            dispatcher: false,
            service: false,
            serviceOrg: false,
            admin: false,
            user: false,
            logist: false,
        },
        client: null,
        menuOpened: true,//for menu sidebar logotype             
        sidebarOpened: false,//for menu sidebar logotype             
        modalBody: false,//for modalForm component    
        cRole:[],   
        roles:[
            {val: "client"},
            {val: "dispatcher"},
            {val: "transporter"},
            {val: "transportOrg"},
        ],        
        tenderStatus: [
            {name: 'statuses.all', value: '', id: 0},
            {name: 'statuses.new',value: 'new', id: 1},
            {name: "statuses.done", value: "done", id: 2},            
            {name: "statuses.cancel", value: "cancel", id: 3},
            {name: "statuses.process", value: "process", id: 4},
        ],
        reviewStatus:[
            {name: 'statuses.all', value: '', id: 0},
            {name: 'statuses.lost', value: 'lost', id: 1},
            {name: 'statuses.win',value: 'win', id: 2},
        ],
        typeOfTansportation: [
            {name: 'sea', val: 1},
            {name: 'avia', val: 2},
            {name: 'jd', val: 3},  
            {name: 'auto', val: 4}, 
            
        ],
        isLoading: false,//global loader animation       
        isNavOpen: false,//old
        userMessages:[]
    },
    modules: {},
    strict: false,
    plugins: debug ? [createLogger()] : [],
    actions:{
        
    },
    getters:{
        getGuidClient: (state, getters, rootState) => {
            if (!state.guidClient && localStorage.getItem("guidClient")) { 
                state.guidClient = localStorage.getItem("guidClient") 
                return state.guidClient;
            }
            else return state.guidClient;            
        },
        getGuidTender: (state, getters, rootState) => {
            if (!state.guidTendert && localStorage.getItem("guidTender")) { 
                state.guidTender = localStorage.getItem("guidTender") 
                return state.guidTender;
            }
            else return state.guidTender;            
        },
        getCurrentUser: (state, getters, rootState) => {
            if (!state.client && localStorage.getItem("client")) { 
                state.client = localStorage.getItem("client") 
                return state.client;
            }
            else return state.client;            
        },
        getUserPdv: (state, getters, rootState) => {
            if (!state.pdv && localStorage.getItem("pdv")) { return localStorage.getItem("pdv") }
            else return state.pdv;
        },
        getUserEmail: (state, getters, rootState) => {            
             return state.email;
        },
        getViewType: (state, getters, rootState) => {
            if (state.viewType){return state.viewType }
            else if (!state.viewType && localStorage.getItem("viewType")) { return localStorage.getItem("viewType") }
            else return "card";
        },
        getUserToken: (state, getters, rootState) => { 
            // console.log(`user_token = ${localStorage.getItem("user-token")}`)          
             if (!state.userToken && localStorage.getItem("user-token")) { 
                state.userToken = localStorage.getItem("user-token")
                return state.userToken
            }
            else return state.userToken
            
        },
        
        getUserRoleAdmin: (state, getters, rootState) => {
            return state.listRole.admin;
        },
        getUserRoleLogist: (state, getters, rootState) => {
            return state.listRole.logist;
        },
        getUserRoleClient: (state, getters, rootState) => {
            return state.listRole.client;
        },
        getUserRoleUser: (state, getters, rootState) => {
            return state.listRole.user;
        },
        getUserMessages: (state, getters, rootState) => {
            return state.userMessages;
        },       
        getNewUserMessages: (state) => {
            return [1];
        },  
        getUserRole:(state) =>{
            return state.cRole; 
        }, 
        getProfilePhoto: state => {
            /*if ((localStorage.getItem('profileImg') !== null ) && (localStorage.getItem('profileTime') !== null) && (localStorage.getItem('profileImg') != 'data:image/jpg;base64,')){
                let dt_last = localStorage.getItem('profileTime');
                let now = Date.now();
    
                let diff = (now - dt_last)/60000;//minutes
    
                if (diff < 30){
                    state.profilePhoto = localStorage.getItem('profileImg');
                } else {
                    localStorage.removeItem('profileImg');
                    localStorage.removeItem('profileTime');
                }
            }*/
            return state.profilePhoto;
        }
    },
    mutations: {
        setCurrentUser(state, user) {
            state.client = user
            localStorage.setItem("client", user)
        },      
        setUser(state, user) {
            state.user = user
            localStorage.setItem("user", user)
        },      
        setUserName(state, date) {
            state.userName = date
            localStorage.setItem("userName", date)
        },      
        setEmail(state, data) {
            state.email = data
            localStorage.setItem("email", data)
        },      
        setGuidUser(state, user) {
            state.guidUser = user
            localStorage.setItem("guidUser", user)
        },      
        setUserLogin(state, data) {
            state.login = data
            localStorage.setItem("login", data)
        },      
        setUserName(state, user) {
            state.userName = user
            localStorage.setItem("userName", user)
        },      
        setClientName(state, data) {
            state.clientName = data
            localStorage.setItem("clientName", JSON.stringify(data))
        },      
        setGuidClient(state, data) {
            state.guidClient = data
            localStorage.setItem("guidClient", data)
        },      
        setClientEdpro(state, data) {
            state.clientEdrpo = data
            localStorage.setItem("clientEdrpo", data)
        },      
        setIp(state, data) {
            state.ip = data
            localStorage.setItem("ip", data)
        },      
        setGuidTender(state, data) {
            state.guidTender = data
            localStorage.setItem("guidTender", data)
        },      
        setUserToken(state, token) {
            state.userToken = token
            localStorage.setItem("user-token", token)
        },      
        setProfilePhoto(state, image){
            state.profilePhoto = image;
            localStorage.setItem('profileImg', image);
        },        
        setUserMessages: (state, messages) => {
            state.userMessages = messages
        },
        setUserRoleAdmin: (state, messages) => {
            state.listRole.admin = messages
            localStorage.setItem("roleAdmin", messages)
        },
        setUserRoleLogist: (state, messages) => {
            state.listRole.logist = messages
        },
        setUserRoleUser: (state, messages) => {
            state.listRole.user = messages
        },
        setUserRoleClient: (state, messages) => {
            state.listRole.client = messages
        },
        setUserRole: (state, messages) => {
            state.cRole.push(messages);
        },
        delUserRole: (state, messages) => {
            state.cRole = [] ;
        },
        setUserPdv: (state, messages) => {
            state.pdv = messages
            localStorage.setItem('pdv', messages);
        },
        setTender: (state, tender) => {
            state.tender = tender
        },
        setViewType: (state, type) => {
            state.viewType = type
            localStorage.setItem("viewType", type)
        },
    }

})


// WEBPACK FOOTER //
// ./src/store/index.js